import React, { useState } from 'react';

const BrandingProjects = () => {
  const [currentProject, setCurrentProject] = useState(0);
  
  const projects = [
    {
      title: 'Corporate Branding for a Tech Startup',
      features: [
        'Developed a modern brand identity & logo',
        'Designed business cards, brochures & marketing materials',
        'Launched a successful digital & print brand campaign'
      ],
      cta: 'Build a Tech Brand That Stands Out!',
      bgColor: 'bg-blue-50'
    },
    {
      title: 'eCommerce Brand Identity & Packaging Design',
      features: [
        'Created a luxury product logo & packaging',
        'Developed a social media brand strategy',
        'Designed high-quality promotional materials'
      ],
      cta: 'Make Your Products Instantly Recognizable!',
      bgColor: 'bg-purple-50'
    },
    {
      title: 'Rebranding for a Local Business',
      features: [
        'Redesigned a modern, fresh logo',
        'Created new business cards, flyers & storefront branding',
        'Successfully launched the new brand with a marketing campaign'
      ],
      cta: 'Give Your Business a Fresh Look with Professional Rebranding!',
      bgColor: 'bg-green-50'
    }
  ];

  const nextProject = () => {
    setCurrentProject((prev) => (prev === projects.length - 1 ? 0 : prev + 1));
  };

  const prevProject = () => {
    setCurrentProject((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
  };

  return (
    <div className="bg-black py-12 px-4 text-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-8 flex items-center">
          <span className="bg-yellow-500 p-2 rounded-full mr-3 text-xl text-black">!</span>
          Recent Branding Projects
        </h2>

        <div className="relative">
          <div className="p-8 rounded-lg border border-yellow-500 transition-all duration-500 bg-gray-900">
            <div className="text-4xl mb-4">{projects[currentProject].icon}</div>
            <h3 className="text-2xl font-bold mb-4 text-yellow-500">{projects[currentProject].title}</h3>
            
            <ul className="space-y-3 mb-6">
              {projects[currentProject].features.map((feature, idx) => (
                <li key={idx} className="flex items-start">
                  <span className="text-yellow-500 mr-2 mt-1 text-lg font-bold">✓</span>
                  <span className="text-gray-300">{feature}</span>
                </li>
              ))}
            </ul>
            
            <button className="bg-yellow-500 text-black font-bold py-2 px-6 rounded-lg hover:bg-yellow-600 transition duration-300">
              {projects[currentProject].cta}
            </button>
          </div>
          
          <div className="absolute top-1/2 -left-4 transform -translate-y-1/2">
            <button 
              onClick={prevProject}
              className="bg-yellow-500 text-black p-2 rounded-full hover:bg-yellow-600 font-bold"
            >
              ←
            </button>
          </div>
          
          <div className="absolute top-1/2 -right-4 transform -translate-y-1/2">
            <button 
              onClick={nextProject}
              className="bg-yellow-500 text-black p-2 rounded-full hover:bg-yellow-600 font-bold"
            >
              →
            </button>
          </div>
          
          <div className="flex justify-center mt-6 space-x-2">
            {projects.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentProject(idx)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  currentProject === idx ? 'bg-yellow-500' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandingProjects;